import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box, Flex, Text } from 'Components/Base';

const TAB_BORDER_STYLE = `
  position: absolute;
  bottom: 0;
  height: 2px;
`;

const ActiveBorder = styled(({ active, ...restProps }) => <Box {...restProps} />)`
  ${TAB_BORDER_STYLE};
  background-color: ${({ theme }) => theme.colors.primary};
  width: ${({ active }) => (active ? '100%' : '0px')};
  transition: ${({ active }) => (active ? 'width 100ms linear' : 'none')};
  z-index: 1;
`;

const InactiveBorder = styled(Box)`
  ${TAB_BORDER_STYLE};
  width: 100%;
  background-color: ${({ theme }) => theme.colors.greyscale.grey5};
`;

const TabLabel = styled(({ itemCount, ...restProps }) => <Box {...restProps} />)`
  position: relative;
  flex-basis: ${({ itemCount }) => `calc(100% / ${itemCount})`};
  flex-grow: 1;
  color: ${({ active, theme }) => (active ? theme.colors.primary : theme.colors.text)};
  cursor: pointer;
`;

const Tab = ({ items, onTabChange }) => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleChange = (e, tabIndex) => {
    setCurrentTab(tabIndex);
    typeof onTabChange === 'function' && onTabChange(items[tabIndex].label);
  };
  return (
    <Fragment>
      <Flex width={'100%'} style={{ position: 'relative' }}>
        {items.map(({ label }, index) => {
          const labelComp =
            typeof label === 'string' ? (
              <Text p={4} textAlign={'center'} color={'inherit'}>
                {label}
              </Text>
            ) : (
              label
            );
          return (
            <TabLabel key={label} itemCount={items.length} onClick={(e) => handleChange(e, index)}>
              {labelComp}
              <ActiveBorder active={currentTab === index} />
            </TabLabel>
          );
        })}
        <InactiveBorder />
      </Flex>

      {items.map(({ content, label }, index) => {
        const contentComp = typeof content === 'string' ? <Text>{content}</Text> : content;
        return currentTab === index && React.cloneElement(contentComp, { key: label });
      })}
    </Fragment>
  );
};

Tab.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    })
  ),
  onTabChange: PropTypes.func,
};

Tab.defaultProps = {
  items: [],
  onTabChange: () => {},
};
export default Tab;
